import React from 'react';
import { Modal } from 'acscp/components/common/modal';

interface ButtonLaunchingModalProps {
    buttonClassName?: string;
    modalClassName?: string;
    modalHeaderClassName?: string;
    closingModalClassName?: string;
    modalHeaderContent?: React.ReactNode;
    overlayClassName?: string;
    buttonContent: React.ReactNode;
    modalBodyClassName?: string;
    childComponentFactory?: (closeModal: () => void) => React.ReactNode;
}
interface ButtonLaunchingModalState {
    isOpen: boolean;
    verticalPosition: number;
}

class ButtonLaunchingModal extends React.Component<ButtonLaunchingModalProps,
    ButtonLaunchingModalState> {
    constructor(props: ButtonLaunchingModalProps) {
        super(props);
        this.state = { isOpen: false, verticalPosition: 0 };
    }

    private openModal = () => this.setState({ isOpen: true, verticalPosition: window.scrollY });
    private closeModal = () => this.setState(
        { isOpen: false },
        () => setTimeout(() => window.scrollTo(0, this.state.verticalPosition), 0)
    )

    render(): JSX.Element {
        return (
            <div style={{display: 'inline'}}>
                <button
                    className={this.props.buttonClassName}
                    onClick={this.openModal}
                >
                    {this.props.buttonContent}
                </button>
                <Modal
                    modalClassName={this.props.modalClassName}
                    modalHeaderClassName={this.props.modalHeaderClassName}
                    closingModalClassName={this.props.closingModalClassName}
                    modalHeaderContent={this.props.modalHeaderContent}
                    overlayClassName={this.props.overlayClassName}
                    modalBodyClassName={this.props.modalBodyClassName}
                    isOpen={this.state.isOpen}
                    closeModal={() => this.closeModal()}
                >
                    {this.props.childComponentFactory
                        ? this.props.childComponentFactory(this.closeModal)
                        : this.props.children}
                </Modal>
            </div>
        );
    }
}

export { ButtonLaunchingModal };
